import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button, ButtonProps } from 'ui-components/common/Button';
import { Link } from 'ui-components/common/Link';

interface LinkButtonProps extends ButtonProps {
  href: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  replace?: boolean;
  fullWidth?: boolean;
}

export const LinkButton = ({ href, className, target, replace, fullWidth, ...props }: LinkButtonProps) => (
  <StyledLink
    href={href}
    className={className}
    target={target}
    replace={replace}
    // Warning: Received `true` for a non-boolean attribute `fullwidth`. 으로 인해 문자열 넘김
    fullwidth={fullWidth ? 'true' : 'false'}>
    <Button {...props} fullWidth />
  </StyledLink>
);

const StyledLink = styled(Link)(
  ({ fullwidth }: { fullwidth: string }) => css`
    width: ${fullwidth === 'true' ? '100%' : 'auto'};
  `,
);
